// extracted by mini-css-extract-plugin
module.exports = {"container":"MyPagePurchaseHistory_container__doTLR","tabs":"MyPagePurchaseHistory_tabs__jbiuY"};